import { render } from "./PasswordList.vue?vue&type=template&id=85e5e06c&scoped=true"
import script from "./PasswordList.vue?vue&type=script&lang=js"
export * from "./PasswordList.vue?vue&type=script&lang=js"

import "./PasswordList.vue?vue&type=style&index=0&id=85e5e06c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85e5e06c"]])

export default __exports__